// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HorizontalStackedAlps_wrapper__KIzFd","alpWrapper":"HorizontalStackedAlps_alpWrapper__3VViE"};